var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asignacionSeriado" },
    [
      _c(
        "div",
        { staticClass: "layout wrap widgets" },
        [
          _c(
            "FormFieldsContainer",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showForm,
                  expression: "!showForm"
                }
              ]
            },
            [
              _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                _c("div", { staticClass: "layout row wrap" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex offset-md10 offset-sm10 xs2 sm2 md2",
                      staticStyle: {
                        "padding-top": "6px",
                        "padding-right": "0px"
                      },
                      attrs: { align: "right" }
                    },
                    [
                      _vm.accionCrear.visible && !_vm.showForm && false
                        ? _c(
                            "v-btn",
                            {
                              staticStyle: { "padding-right": "20px" },
                              attrs: {
                                disabled: _vm.deshabilitar,
                                color: "#ffe800"
                              },
                              on: { click: _vm.handleCrearClick }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { color: "black" },
                                  attrs: { dark: "", left: "" }
                                },
                                [_vm._v("add_circle_outline\n              ")]
                              ),
                              _c("span", { staticStyle: { color: "black" } }, [
                                _vm._v("Crear")
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _c("v-flex", {
                staticStyle: { "padding-right": "0px" },
                attrs: {
                  md2: "",
                  "offset-md10": "",
                  "offset-sm10": "",
                  sm2: ""
                }
              }),
              _c("br"),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md12: "", layout: "" } },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm12: "", md12: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btnPlantilla",
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.descargarPlantilla("PENDIENTES")
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("cloud_download")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Descargar Pendientes por Finalizar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm12: "", md12: "", layout: "" } },
                        [
                          _c("p", { staticClass: "aclaracion" }, [
                            _vm._v(
                              "\n              Utilice el formato de la siguiente plantilla para evitar\n              conflictos al momento de cargar la solicitud.\n            "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm6 md6" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          xs3: "",
                          sm3: "",
                          md3: "",
                          label: "Seleccione Archivo para carga masiva",
                          heigh: "",
                          "error-messages": _vm.errors.collect("archivo"),
                          "data-vv-name": "archivo",
                          readonly: "readonly"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$refs.image.click()
                          }
                        },
                        model: {
                          value: _vm.fileName,
                          callback: function($$v) {
                            _vm.fileName = $$v
                          },
                          expression: "fileName"
                        }
                      }),
                      _c("input", {
                        ref: "image",
                        staticStyle: { display: "none" },
                        attrs: {
                          type: "file",
                          accept: ".xlsx, .xls",
                          clearable: "",
                          id: "archivoExcel"
                        },
                        on: { change: _vm.prepare_file_upload }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs2 sm2 md2" },
                    [
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.fileName,
                              expression: "fileName"
                            }
                          ],
                          staticStyle: { "margin-top": "10px" },
                          on: { click: _vm.quitarRegistro }
                        },
                        [_vm._v("✖")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs2 sm2 md2" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "btn-sucursal btn-cargar v-btn theme--light",
                          staticStyle: { "margin-top": "10px" },
                          attrs: { disabled: _vm.errorArchivo },
                          on: { click: _vm.cargar }
                        },
                        [
                          _c("v-icon", [_vm._v("attach_file")]),
                          _vm._v("Cargar\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "text-xs-center" },
                [
                  _c(
                    "v-dialog",
                    {
                      attrs: { width: "500" },
                      model: {
                        value: _vm.errorArchivoModal,
                        callback: function($$v) {
                          _vm.errorArchivoModal = $$v
                        },
                        expression: "errorArchivoModal"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "headline lighten-2",
                              attrs: { "primary-title": "" }
                            },
                            [_vm._v("Error al leer el archivo")]
                          ),
                          _c("v-card-text", {
                            domProps: { innerHTML: _vm._s(_vm.errorMessage) }
                          }),
                          _c("v-divider"),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", flat: "" },
                                  on: { click: _vm.quitarRegistro }
                                },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider", { staticClass: "mb-4" }),
      _vm.dialogEditSeriado
        ? _c("ModalEditSeriado", {
            attrs: {
              data: _vm.data,
              isEdit: _vm.isEdit,
              deshabilitar: _vm.deshabilitar,
              funcionalidad: _vm.funcionalidad,
              notify: _vm.$snotify
            },
            on: { closeModalSeriado: _vm.closeModalSeriado }
          })
        : _vm._e(),
      _vm.dialogDevolverSeriado
        ? _c("ModalDevolverSeriado", {
            attrs: {
              data: _vm.data,
              dialog: true,
              funcionalidad: _vm.funcionalidad
            },
            on: { closeModalSeriado: _vm.closeModalSeriado }
          })
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showForm,
              expression: "!showForm"
            }
          ],
          staticClass: "gridcard rounded-card",
          staticStyle: { "padding-top": "6px", "padding-right": "0px" },
          attrs: { align: "left" }
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "", sm4: "", md4: "" } },
                [
                  _c("v-text-field", {
                    staticStyle: { "padding-left": "15px" },
                    attrs: { label: "Buscar..." },
                    on: { input: _vm.searchData },
                    model: {
                      value: _vm.filtrobusquedagrilla,
                      callback: function($$v) {
                        _vm.filtrobusquedagrilla = $$v
                      },
                      expression: "filtrobusquedagrilla"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs8: "", sm8: "", md8: "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: {
                        "padding-top": "20px",
                        "padding-right": "5px"
                      },
                      attrs: { "justify-end": "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            small: "",
                            "data-permiso": "Exportar",
                            color: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.descargarPlantilla("ALL")
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "icon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("  \n            "),
                          _c("span", { staticClass: "text" }, [
                            _vm._v("Exportar")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "grid-container" }, [
            _c("div", { staticClass: "fake-vertical-scrollbar" }),
            _c(
              "div",
              {
                ref: "gridContainerRef",
                staticClass: "Seriados",
                class: { ocultar_acciones: _vm.deshabilitar }
              },
              [
                _c("MantenedorGridSinCodigo", {
                  attrs: {
                    "funcionalidad-id": _vm.funcionalidad,
                    "grid-options": _vm.gridOptions
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }